/* eslint-disable class-methods-use-this */
import { Observable } from 'rxjs';

class ErrorMapping {
  throwError(error: any): Observable<any> {
    if (error?.response) {
      throw new Error(
        JSON.stringify({
          code: error.response.error.codigo,
          type: error.response.error.tipo,
          message: error.response.error.mensaje,
        }),
      );
    } else {
      throw new Error(
        'Ocurrió un error en la cotización, favor intenta en unos minutos.',
      );
    }
  }
}
export default ErrorMapping;
